<template>
    <div class="card">
        <div class="card-header">
            <div class="card-title">
                <i class="fa fa-angle-double-left mr-2" style=" cursor: pointer; font-size: 30px;color: #1e5c9e; float: left;" @click="$router.go(-1)"></i>
            </div>
            <div class="card-toolbar">
                <span style="font-weight: bold;">วันที่ต้องการสินค้า:</span>&nbsp;&nbsp;&nbsp;&nbsp;
                    <el-date-picker
                        v-model="arrivalDate"
                        type="date"
                        placeholder="Pick a day"
                        :disabled-date="disabledDate"
                        :size="size"
                        style="max-width: 150px"  
                        format="DD/MM/YYYY"
                    />                                   
            </div>
        </div>            
        <div class="card-body">
            <div class="table-responsive">
                <table
                    class="table g-5 gs-0 mb-0 fw-bolder text-gray-700"
                    data-kt-element="items"                
                >
                    <thead>
                        <tr
                            class="
                                border-bottom
                                fs-7
                                fw-bolder
                                text-gray-700 text-uppercase
                            "                        
                        >
                            <th class="min-w-30px w-30px">#</th>
                            <th class="min-w-250px w-250px">สินค้า</th>
                            <th class="min-w-80px w-80px text-end">คงเหลือ</th>
                            <th class="min-w-80px w-80px text-end">คงเหลือ 2S</th>
                            <th class="min-w-150px w-150px text-center">จำนวนมัด</th>
                            <th class="min-w-150px w-150px text-center">จำนวนเศษ</th>
                            <th class="min-w-150px w-150px text-center">จำนวนรวม</th>
                            <th class="min-w-100px w-100px text-end">น้ำหนัก</th>
                            <th class="min-w-50px w-50px text-end"></th>
                        </tr>
                    </thead> 
                    <tbody>
                        <tr
                            class="border-bottom border-bottom-dashed"
                            data-kt-element="item"
                            v-for="(product, index) in products"
                            :key="index"                        
                        >
                            <td class="pt-6 pe-7">{{ index + 1 }}</td>
                            <td class="pt-6 pe-7">
                                {{ product.productName }}&nbsp;[{{ numberWithCommas(product.productWeight) }} กก.]
                                <br>
                                <span class="text-gray-500 fs-7 fw-bold">{{ numberWithCommas(product.priceQuanPerPack, 0) }} เส้น/มัด</span>
                            </td>
                            <td class="pt-6 pe-7 text-end text-nowrap">{{ numberWithCommas(product.stockQuantity,0) }}</td>
                            <td class="pt-6 pe-7 text-end text-nowrap">{{ numberWithCommas(product.stockQuantity2S,0) }}</td>
                            <td class="ps-0 text-center" v-show="product.productSellBundle || product.priceSplitBundle > 0">
                                        <el-button type="primary" style="height: 30px; width: 30px; padding: 12px 5px;" @click="bundlePlus(product)" >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
                                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                                            </svg>
                                        </el-button>&nbsp;
                                        <NumberInput v-model="product.quanBundle" :min="0" placeholder="มัด"  :style="{'width': '50px'}" @focus="$event.target.select()"/>&nbsp;
                                        <el-button type="primary" style="height: 30px; width: 30px; padding: 12px 5px;" @click="bundleDel(product)" :disabled="product.quanBundle <= 0">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-dash-circle" viewBox="0 0 16 16">
                                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                            <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"/>
                                            </svg>
                                        </el-button>                                                                       
                            </td>
                            <td class="ps-0 text-center" v-show="(product.productSellBundle || product.priceSplitBundle) > 0 && product.stockQuantity2SBundle == 0 && product.stockQuantity2SPiece > 0">
                                        <el-button type="primary" style="height: 30px; width: 30px; padding: 12px 5px;" @click="piecePlus(product)" :disabled="product.quanPiece >= product.stockQuantity2SPiece" >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
                                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                                            </svg>
                                        </el-button>&nbsp;
                                        <NumberInput v-model="product.quanPiece" :min="0" :max="product.stockQuantity2SPiece" placeholder="เศษ" :style="{'width': '50px'}" @focus="$event.target.select()"/>&nbsp;
                                        <el-button type="primary" style="height: 30px; width: 30px; padding: 12px 5px;" @click="pieceDel(product)" :disabled="product.quanPiece <= 0">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-dash-circle" viewBox="0 0 16 16">
                                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                            <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"/>
                                            </svg>
                                        </el-button> 
                                        <br>
                                        <!-- เศษ&nbsp;<span style="color: red;">{{ numberWithCommas(product.stockQuantity2SPiece,0) }}</span>&nbsp;เส้น                                                                                                               -->
                            </td>                
                            <td class="pt-6 pe-7 text-center" v-show="(product.productSellBundle || product.priceSplitBundle) > 0 && (product.stockQuantity2S == 0 ||product.stockQuantity2SBundle > 0)">-</td>             
                            <td class="pt-6 pe-7 text-center" v-show="!product.productSellBundle && product.priceSplitBundle == 0">-</td>
                            <td class="ps-0 text-center" v-show="!product.productSellBundle && product.priceSplitBundle == 0">
                                        <el-button type="primary" style="height: 30px; width: 30px; padding: 12px 5px;" @click="quanPlus(product)" >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
                                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                                            </svg>
                                        </el-button>&nbsp;
                                        <NumberInput v-model="product.quantity" :min="1" :max="10" placeholder="เส้น" :style="{'width': '65px'}" @focus="$event.target.select()"/>&nbsp;
                                        <el-button type="primary" style="height: 30px; width: 30px; padding: 12px 5px;" @click="quanDel(product)" :disabled="product.quantity <= 0">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-dash-circle" viewBox="0 0 16 16">
                                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                            <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"/>
                                            </svg>
                                        </el-button>  
                                        <br>
                                        <span style="color: green;">{{ numberWithCommas(sumBundle(product),0) }}</span>&nbsp;มัด&nbsp;&nbsp;<span style="color: green;">{{ numberWithCommas(product.quantity%product.priceQuanPerPack,0) }}</span>&nbsp;เส้น
                            </td>                                    
                            <td class="pt-6 pe-7 text-center" v-show="product.productSellBundle || product.priceSplitBundle > 0">{{ numberWithCommas(sumQuantity(product),0) }}</td>                
                            <td class="pt-6 pe-7 text-end text-nowrap">{{ numberWithCommas(sumWeight(product)) }}</td>
                            <td class="pt-3 text-end">
                                <button
                                type="button"
                                class="btn btn-sm btn-icon btn-active-color-primary"
                                data-kt-element="remove-item"
                                @click="() => deleteProduct(index)"
                                >
                                <!--begin::Svg Icon | path: icons/duotune/general/gen027.svg-->
                                <span class="svg-icon svg-icon-3">
                                    <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    >
                                    <path
                                        d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z"
                                        fill="black"
                                    ></path>
                                    <path
                                        opacity="0.5"
                                        d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z"
                                        fill="black"
                                    ></path>
                                    <path
                                        opacity="0.5"
                                        d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z"
                                        fill="black"
                                    ></path>
                                    </svg>
                                </span>
                                <!--end::Svg Icon-->
                                </button>
                            </td>                            
                        </tr>    
                    </tbody>                   
                </table>
                <div class="text-center p-10" v-if="products.length == 0">
                <button
                    class="btn btn-text-primary"
                    type="button"
                    @click="showSearchTransferBookProductModal"
                >
                    เพิ่มสินค้า
                </button>
                </div>                
            </div>
            <div class="separator separator-dashed mb-5"></div>
          <div class="row fw-bolder text-gray-700">
            <div class="col-md-6 mb-10">
              <button
                class="btn btn-light-primary"
                type="button"
                @click="showSearchTransferBookProductModal"
              >
                เพิ่มสินค้า
              </button>

              <div class="mt-10">
                <label class="form-label fs-6 fw-bolder text-gray-700 mb-3"
                  >หมายเหตุ</label
                >
                <div class="mb-5">
                  <el-input
                    type="textarea"
                    placeholder="หมายเหตุ"
                    v-model="remark"
                    maxlength="200"
                    show-word-limit
                    rows="3"
                  >
                  </el-input>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-5 offset-lg-1 fs-5 fw-bolder">
              <div class="
                text-gray-700
                fs-6
                card
                bg-light
                rounded-3
                mb-3">
                <div class="card-body">
                  <div class="d-flex flex-row justify-content-between mb-6">
                    <div>จำนวนรวม (เส้น.)</div>
                    <div>{{ numberWithCommas(totalQuantity,0) }}</div>
                  </div>                    
                  <div class="d-flex flex-row justify-content-between mb-3">
                    <div>น้ำหนักรวม (กก.)</div>
                    <div>{{ numberWithCommas(totalWeight) }}</div>
                  </div>
                </div>
              </div>
              <button class="btn btn-primary w-100" @click="create" :disabled="products.length==0">ยืนยัน</button>
            </div>
          </div>            
        </div>
    <loading 
        v-model:active="isLoading"
        :loader="dots" 
        :is-full-page="false"/>         
    <search-transfer-book-product-modal
      v-model="products"
      ref="searchTransferBookProductModalRef"
    ></search-transfer-book-product-modal>        
    </div>
</template>


<script>

import ApiService from "@/core/services/ApiService";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { numberWithCommas, formatDateFromISO } from "@/utils";
import Loading from 'vue-loading-overlay';
import SearchTransferBookProductModal from "@/components/modals/search/SearchTransferBookProductModal";
import NumberInput from '@/components/forms/NumberInput'
import Swal from "sweetalert2/dist/sweetalert2.js";
import { DateTime } from 'luxon'

export default {  
    created() {
        var date = new Date();
        date.setDate(date.getDate() + 1);
        this.arrivalDate = date;
    },  
    watch: {
        "$route.query.prods": {
        immediate: true,
        handler: function (val) {
            // console.log(val)
            if (!val || val.length == 0) return;
            if (Array.isArray(val)) {
            this.findProducts(val);
            } else {
            this.findProducts([val]);
            }
            // console.log(val)
        },
        },
    },      
    mounted: function (){
        setCurrentPageBreadcrumbs("จองย้ายสินค้า", []);  
    },    
    components: {
        Loading,
        SearchTransferBookProductModal,
        NumberInput,
    },
    computed: {
        totalQuantity() {
            return this.products.reduce((acc, curr) => acc + parseInt(curr.quantity), 0);
        },        
        totalWeight() {
            return this.products.reduce((acc, curr) => acc + this.sumWeight(curr), 0);
        },
    },        
    data(){
        return{
            products: [],           
            isLoading: false,
            remark: "",
            arrivalDate: null,
        }
    },
    methods: {
        findProducts: async function (productIds) {
        const { data } = await ApiService.query("products", {
            params: { productIds: productIds.join() },
        });

        this.products = data;
        
        this.products.forEach(p => {
            p.quanBundle = parseInt(1);
            p.quantity = parseInt(1);
            p.quanPiece = parseInt(0);
        });

        },        
        showSearchTransferBookProductModal() {
          this.$refs.searchTransferBookProductModalRef.show();
        },    
        deleteProduct(index) {
            this.products.splice(index, 1);
        },       
        create: async function(){

            const hasZeroQuantity = this.products.some(
                (product) => isNaN(parseInt(product.quantity)) || parseInt(product.quantity) <= 0
            );
            if (hasZeroQuantity) {
                Swal.fire({
                    title: "กรุณาระบุจำนวนให้ครบทุกรายการ",
                    icon: "warning",
                    buttonsStyling: false,
                    confirmButtonText: "ปิด",
                    allowOutsideClick: false,
                    customClass: {
                        confirmButton: "btn btn-primary",
                    },
                });
                return;
            }

            this.isLoading = true;

            var productData = [];
            this.products.forEach((column, index) => {
                productData.push(column["productID"] + "|" + column["quantity"] + "|" + column["weightTotal"]);
            }); 

            // console.log(productData)
            
            try {
                const { data } = await ApiService.post("TransferStore/TransferBookCreate", {
                items: productData.join(","),
                remark: this.remark,
                arrivalDate: DateTime.fromJSDate (this.arrivalDate).toFormat('yyyy-MM-dd'),
                });

                if (data["success"] == 1) {
                    Swal.fire({
                        icon: "success",
                        title: data["error_Text"],
                        timer:1500,
                        showCancelButton: false,
                        showConfirmButton: false,                  
                        allowOutsideClick: false,
                        didDestroy: () => {
                            this.$router.push({ name: 'transfer' })
                        },  
                    });                             
                } else if (data["success"] == 0) {
                    Swal.fire({
                        icon: "error",
                        title: "เกิดข้อผิดพลาด",
                        allowOutsideClick: false,
                        text: data["error_Text"],
                    });
                } else {
                    Swal.fire({
                        text: "เกิดข้อผิดพลาด ไม่สามารถทำรายการได้!",
                        icon: "warning",
                        buttonsStyling: false,
                        confirmButtonText: "ปิด",
                        allowOutsideClick: false,
                        customClass: {
                        confirmButton: "btn btn-primary",
                        },
                    });
                }
            } catch (error) {
                console.log(error);
            }            

            this.isLoading = false;

        },
        callTransferBook(){
            this.$router.push({name: "transferbook"});
            this.products = [];    
        }, 
        sumBundle(product){
            if(!product.productSellBundle && product.priceSplitBundle == 0){
                const { priceQuanPerPack, quantity } = product;
                product.quanBundle = parseInt((isNaN(quantity) ? 0 : quantity) / (isNaN(priceQuanPerPack) ? 0 : priceQuanPerPack));
                return (
                    parseInt((isNaN(quantity) ? 0 : quantity) / (isNaN(priceQuanPerPack) ? 0 : priceQuanPerPack))
                );
            }
        },         
        sumQuantity(product){
            if(product.productSellBundle || product.priceSplitBundle > 0){
                const { priceQuanPerPack, quanBundle, quanPiece } = product;
                const total = parseInt((isNaN(priceQuanPerPack) ? 0 : priceQuanPerPack) * (isNaN(quanBundle) ? 0 : quanBundle)) + parseInt(isNaN(quanPiece) ? 0 : quanPiece);
                product.quantity = total;
                return total;
            }
        },        
        sumWeight(product) {
            const { productWeight, quantity } = product;
            product.weightTotal = (isNaN(productWeight) ? 0 : productWeight) * (isNaN(quantity) ? 0 : quantity);
            return (
                (isNaN(productWeight) ? 0 : productWeight) * (isNaN(quantity) ? 0 : quantity)
            );
        },    
        bundlePlus(product){
            product.quanBundle = (product.quanBundle * 1) + parseInt(1);
            product.quantity = (product.priceQuanPerPack * product.quanBundle) + (product.quanPiece * 1);
        },
        bundleDel(product){
            product.quanBundle = (product.quanBundle <= parseInt(0)) ? parseInt(0) : (product.quanBundle * 1) - parseInt(1);
            product.quantity = (product.priceQuanPerPack * product.quanBundle) + (product.quanPiece * 1);
        },
        piecePlus(product){
            product.quanPiece = (product.quanPiece * 1) + parseInt(1);
            product.quantity = (product.priceQuanPerPack * product.quanBundle) + (product.quanPiece * 1);
        },
        pieceDel(product){
            product.quanPiece = (product.quanPiece <= parseInt(0)) ? parseInt(0) : (product.quanPiece * 1) - parseInt(1);
            product.quantity = (product.priceQuanPerPack * product.quanBundle) + (product.quanPiece * 1);
        },
        quanPlus(product){
            product.quanBundle = (product.quanBundle * 1) + parseInt(1);
            product.quantity = parseInt((product.quanBundle * 1) * (product.priceQuanPerPack * 1));
        },
        quanDel(product){
            product.quanBundle = ((product.quanBundle == parseInt(1)) || product.quantity <= product.priceQuanPerPack) ? parseInt(1) : (product.quanBundle * 1) - parseInt(1);
            product.quantity = parseInt((product.quanBundle * 1) * (product.priceQuanPerPack * 1));
        },      
        getPriceQuanPerPack(product){
            return product.priceQuanPerPack + " เส้น/มัด";
        },                 
        numberWithCommas,
    }
}
</script>

<style>
.el-input.is-disabled .el-input__inner {
    color: #000000;
}
.table.g-5 th, .table.g-5 td {
    padding: 0.5rem;
}
</style>